import React from 'react';
import ShipmentFormatter from './ShipmentFormatter';

export const shipmentFormatter = (cell, row) => <ShipmentFormatter shipment={row} />;

export default shipmentFormatter;
